// extracted by mini-css-extract-plugin
export default {"header":"muiModal_header__CvxtF","modalContent":"muiModal_modalContent__fa4kC","footer":"muiModal_footer__GBedk"};